/* ---------------------------------------------------------------------------
   BD CAROUSEL — scorrimento continuo e indicatori di posizione
   Bottega Dalmut, 8 settembre 2026

   Le schede avanzano da sole, sempre verso destra, e dopo l'ultima riparte la
   prima senza mai tornare indietro.

   Il giro infinito si ottiene appendendo in coda una copia delle schede: si
   scorre dentro la copia e, appena il primo giro e' concluso, la posizione
   viene riportata indietro di un giro esatto senza animazione. Il contenuto
   sotto e' identico, quindi il salto non si vede: a schermo il movimento
   resta continuo in una sola direzione.

   Non tocca il custom element di Prestige e non ne usa i metodi: muove la
   barra di scorrimento nativa. Se il tema cambia, al massimo smette di
   avanzare, ma il carosello resta usabile a mano.

   Si ferma da solo quando serve: se l'utente lo tocca, se la sezione non e'
   a schermo, se la scheda del browser passa in secondo piano, e se chi guarda
   ha chiesto meno animazioni.

   21 settembre 2026 — aggiunte facoltative, valgono solo dove sono chieste
   (le Collection List non le usano e restano come prima):
   - data-bd-prev / data-bd-next: id delle frecce. Avanti usa lo stesso giro
     infinito; indietro dalla prima scheda salta sulla sua copia e torna di un
     passo, cosi' si arriva all'ultima senza riavvolgere a vista.
   - data-bd-pausa-hover: col mouse sopra si ferma, si legge con calma.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  var RIPRESA_DOPO = 4000; // ms di quiete prima di ripartire dopo un tocco

  function Auto(el) {
    this.el = el;
    this.autoplayAttivo = el.hasAttribute('data-bd-autoplay');
    this.intervallo = (parseFloat(el.getAttribute('data-bd-autoplay')) || 4) * 1000;
    this.soloSotto = parseInt(el.getAttribute('data-bd-autoplay-until'), 10) || 0;
    this.timer = null;
    this.riavvio = null;
    this.attesaScroll = null;
    this.inVista = false;
    this.inPausa = false;
    this.originali = el.children.length;

    var contenitoreDots = el.getAttribute('data-bd-dots');
    this.dots = contenitoreDots ? document.getElementById(contenitoreDots) : null;
    this.pulsanti = [];

    this.avanza = this.avanza.bind(this);
    this.sospendi = this.sospendi.bind(this);
    this.valuta = this.valuta.bind(this);
    this.alloScroll = this.alloScroll.bind(this);

    // Il dito o il mouse hanno sempre la precedenza sull'automatismo.
    ['pointerdown', 'wheel', 'touchstart', 'focusin'].forEach(function (evento) {
      el.addEventListener(evento, this.sospendi, { passive: true });
    }, this);

    // Il riallineamento vale anche per lo scorrimento fatto a mano: cosi il
    // giro resta infinito comunque lo si muova.
    el.addEventListener('scroll', this.alloScroll, { passive: true });

    this.collegaFrecce();
    this.collegaPausaHover();

    if (typeof IntersectionObserver !== 'undefined') {
      var self = this;
      new IntersectionObserver(function (voci) {
        self.inVista = voci[0].isIntersecting;
        self.valuta();
      }, { threshold: 0.35 }).observe(el);
    } else {
      this.inVista = true;
    }

    window.addEventListener('resize', this.valuta);
    document.addEventListener('visibilitychange', this.valuta);

    this.creaDots();
    this.valuta();
    this.aggiornaDots();
  }

  /* --------------------------------------------------------------------- */
  /* Frecce e pausa al passaggio del mouse (facoltative)                    */
  /* --------------------------------------------------------------------- */

  Auto.prototype.collegaFrecce = function () {
    var self = this;
    var prec = document.getElementById(this.el.getAttribute('data-bd-prev') || '');
    var succ = document.getElementById(this.el.getAttribute('data-bd-next') || '');

    // Una freccia premuta vale come un tocco: l'automatismo aspetta, poi riparte.
    if (succ) {
      succ.addEventListener('click', function () {
        self.sospendi();
        self.avanti();
      });
    }

    if (prec) {
      prec.addEventListener('click', function () {
        self.sospendi();
        self.indietro();
      });
    }
  };

  Auto.prototype.collegaPausaHover = function () {
    if (!this.el.hasAttribute('data-bd-pausa-hover')) return;

    var self = this;

    this.el.addEventListener('mouseenter', function () {
      self.inPausa = true;
      self.ferma();
    });

    this.el.addEventListener('mouseleave', function () {
      self.inPausa = false;
      self.valuta();
    });
  };

  Auto.prototype.avanti = function () {
    this.preparaGiro();
    this.el.scrollTo({ left: this.el.scrollLeft + this.passo(), behavior: 'smooth' });
  };

  /* Indietro dalla prima scheda: ci si sposta senza animazione sulla sua copia
     (identica, il salto non si vede) e da li' si torna di un passo, cioe'
     sull'ultima scheda. Il riallineamento non interviene: si resta sotto il
     giro. */
  Auto.prototype.indietro = function () {
    this.preparaGiro();

    var passo = this.passo();
    var giro = this.lunghezzaGiro();

    if (giro > 0 && this.el.scrollLeft < passo / 2) {
      var comportamento = this.el.style.scrollBehavior;
      this.el.style.scrollBehavior = 'auto';
      this.el.scrollLeft = this.el.scrollLeft + giro;
      this.el.style.scrollBehavior = comportamento;
    }

    this.el.scrollTo({ left: this.el.scrollLeft - passo, behavior: 'smooth' });
  };

  /* --------------------------------------------------------------------- */
  /* Indicatori: quanti sono e dove ci si trova                             */
  /* --------------------------------------------------------------------- */

  /* L'etichetta arriva dal tema gia' tradotta e passata al setaccio per finire
     dentro un attributo: l'apostrofo di "Vai all'articolo" ci arriva come
     codice. Va riportato in chiaro, altrimenti un lettore di schermo si
     ritroverebbe a scandire la sequenza di caratteri. */
  function inChiaro(testo) {
    if (testo.indexOf('&') === -1) return testo;

    var area = document.createElement('textarea');
    area.innerHTML = testo;
    return area.value;
  }

  Auto.prototype.creaDots = function () {
    if (!this.dots || this.originali < 2) return;

    var modello = inChiaro(this.dots.getAttribute('data-bd-dots-label') || 'Vai a {n}');
    var self = this;

    for (var i = 0; i < this.originali; i++) {
      var pulsante = document.createElement('button');
      pulsante.type = 'button';
      pulsante.className = 'bd-dots__dot';
      pulsante.setAttribute('aria-label', modello.replace('{n}', i + 1));
      pulsante.setAttribute('aria-current', i === 0 ? 'true' : 'false');

      // Toccare un indicatore e' come toccare le schede: l'automatismo si
      // ferma e riprende dopo, altrimenti scapperebbe via da solo.
      (function (indice) {
        pulsante.addEventListener('click', function () {
          self.vaiA(indice);
          self.sospendi();
        });
      })(i);

      this.dots.appendChild(pulsante);
      this.pulsanti.push(pulsante);
    }
  };

  Auto.prototype.vaiA = function (indice) {
    var scheda = this.el.children[indice];
    if (!scheda) return;

    var origine = this.el.children[0].offsetLeft;
    this.el.scrollTo({ left: scheda.offsetLeft - origine, behavior: 'smooth' });
  };

  /* La scheda in vista si ricava dalla posizione: il resto della divisione per
     un giro tiene conto anche di quando si sta scorrendo dentro le copie. */
  Auto.prototype.aggiornaDots = function () {
    if (!this.pulsanti.length) return;

    var passo = this.passo();
    if (passo <= 0) return;

    var giro = this.lunghezzaGiro();
    var posizione = this.el.scrollLeft;
    if (giro > 0) posizione = posizione % giro;

    var indice = Math.round(posizione / passo) % this.originali;
    if (indice < 0) indice = 0;

    for (var i = 0; i < this.pulsanti.length; i++) {
      this.pulsanti[i].setAttribute('aria-current', i === indice ? 'true' : 'false');
    }
  };

  /* Va avanti solo se ha senso: carosello a schermo, scheda attiva, larghezza
     giusta e qualcosa da scorrere. */
  Auto.prototype.puoAndare = function () {
    if (!this.autoplayAttivo) return false;
    if (this.inPausa) return false;
    if (document.hidden || !this.inVista) return false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (this.soloSotto && window.innerWidth > this.soloSotto) return false;

    // Nascosto da una media query del tema: niente da far scorrere.
    if (this.el.offsetParent === null) return false;

    return this.el.scrollWidth - this.el.clientWidth > 8;
  };

  /* La copia si aggiunge solo quando il carosello parte davvero: se resta
     fermo, il tema non si ritrova schede doppie fra i piedi. */
  Auto.prototype.preparaGiro = function () {
    if (this.copiePronte) return;

    var schede = Array.prototype.slice.call(this.el.children);
    if (schede.length < 2) return;

    this.copiePronte = true;

    schede.forEach(function (scheda) {
      var copia = scheda.cloneNode(true);

      // Le copie servono solo all'occhio: niente lettori di schermo, niente
      // tabulazione, altrimenti il menu di navigazione avrebbe voci doppie.
      copia.setAttribute('aria-hidden', 'true');
      copia.setAttribute('data-bd-copia', '');
      copia.setAttribute('tabindex', '-1');

      var interattivi = copia.querySelectorAll('a, button, input, [tabindex]');
      for (var i = 0; i < interattivi.length; i++) {
        interattivi[i].setAttribute('tabindex', '-1');
      }

      this.el.appendChild(copia);
    }, this);
  };

  /* Quanto misura un giro completo: la distanza fra la prima scheda e la sua
     copia. Si ricalcola ogni volta perche' cambia col ridimensionamento. */
  Auto.prototype.lunghezzaGiro = function () {
    var schede = this.el.children;
    if (!this.copiePronte || schede.length <= this.originali) return 0;

    var inizio = schede[0].getBoundingClientRect().left;
    var inizioCopia = schede[this.originali].getBoundingClientRect().left;

    return inizioCopia - inizio;
  };

  /* Concluso un giro si torna indietro di un giro esatto, di colpo e senza
     animazione: sotto c'e' la stessa immagine, quindi il salto non si vede.

     Il ritorno si aggancia alla scheda piu' vicina invece di sottrarre e
     basta: lo scorrimento morbido non si ferma mai al pixel esatto, e senza
     questo il carosello slitterebbe di qualche pixel a ogni giro, fino a
     mostrare le schede tagliate dopo un po' che la pagina resta aperta. */
  Auto.prototype.riallinea = function () {
    var giro = this.lunghezzaGiro();
    if (giro <= 0) return;
    if (this.el.scrollLeft < giro - 1) return;

    var schede = this.el.children;
    var origine = schede[0].offsetLeft;
    var obiettivo = this.el.scrollLeft - giro;
    var scelta = obiettivo;
    var minima = Infinity;

    for (var i = 0; i < this.originali; i++) {
      var posizione = schede[i].offsetLeft - origine;
      var distanza = Math.abs(posizione - obiettivo);

      if (distanza < minima) {
        minima = distanza;
        scelta = posizione;
      }
    }

    var comportamento = this.el.style.scrollBehavior;
    this.el.style.scrollBehavior = 'auto';
    this.el.scrollLeft = scelta;
    this.el.style.scrollBehavior = comportamento;
  };

  /* Si aspetta che lo scorrimento si fermi: riallineare a meta' animazione la
     interromperebbe a scatti. */
  Auto.prototype.alloScroll = function () {
    this.aggiornaDots();

    clearTimeout(this.attesaScroll);
    this.attesaScroll = setTimeout(this.riallinea.bind(this), 120);
  };

  Auto.prototype.valuta = function () {
    if (this.puoAndare()) this.avvia();
    else this.ferma();
  };

  Auto.prototype.avvia = function () {
    if (this.timer) return;
    this.preparaGiro();
    this.timer = setInterval(this.avanza, this.intervallo);
  };

  Auto.prototype.ferma = function () {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  };

  Auto.prototype.sospendi = function () {
    this.ferma();
    clearTimeout(this.riavvio);
    this.riavvio = setTimeout(this.valuta, RIPRESA_DOPO);
  };

  /* Il passo e' la larghezza di una scheda, non dello schermo: cosi avanza di
     una card per volta anche quando se ne vedono due. */
  Auto.prototype.passo = function () {
    var prima = this.el.firstElementChild;
    if (!prima) return this.el.clientWidth;

    var seconda = prima.nextElementSibling;

    if (seconda) {
      var distanza = seconda.getBoundingClientRect().left - prima.getBoundingClientRect().left;
      if (distanza > 0) return distanza;
    }

    return prima.getBoundingClientRect().width || this.el.clientWidth;
  };

  /* Sempre in avanti. Il ritorno alla prima scheda non e' un passo indietro:
     lo fa il riallineamento, che sposta la posizione mentre a schermo scorre
     la copia. */
  Auto.prototype.avanza = function () {
    if (!this.puoAndare()) { this.ferma(); return; }

    this.el.scrollTo({ left: this.el.scrollLeft + this.passo(), behavior: 'smooth' });
  };

  function init(scope) {
    var nodi = (scope || document).querySelectorAll('[data-bd-carousel]');
    for (var i = 0; i < nodi.length; i++) {
      if (!nodi[i].bdAuto) nodi[i].bdAuto = new Auto(nodi[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
